cdb.config.set('assets_url', '//cartodb-libs.global.ssl.fastly.net/cartodbui/assets/4.7.36');
console.log('cartodbui v4.7.36');